interface Props {
    path: string;
}

/**
 * integration with https://customers.ai/
 * a meta partner who is a Visitor ID Provider
 */
export const CustomersAi: React.FC<Props> = ({ path }) => {
    const src = `https://mm-uxrv.com/js/${path}.js`;
    return (
        <script
            id="customersAi-script"
            type="text/javascript"
            async={true}
            src={src}
        />
    );
};
